// use a script tag or an external JS file
 document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger)

    const animContainer = document.getElementById("lottie-container");
    const lottieLink = animContainer.dataset.lottieLink;

    const anim = lottie.loadAnimation({
      container: animContainer,
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: lottieLink
    });
  
    anim.addEventListener("DOMLoaded", function () {
        const totalFrames = anim.totalFrames;
        const obj = { frame: 0 };
        gsap.to(obj, {
        frame: totalFrames - 1,
        ease: "none",
        duration: 5, 
        repeat: -1,   
        onUpdate: () => {
            anim.goToAndStop(Math.floor(obj.frame), true);
        }
        });
      });
   });